import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';
let FormlySelectOptionsPipe = /*#__PURE__*/(() => {
  class FormlySelectOptionsPipe {
    transform(options, field) {
      if (!(options instanceof Observable)) {
        options = this.observableOf(options, field);
      } else {
        this.dispose();
      }
      return options.pipe(map(value => this.transformOptions(value, field)));
    }
    ngOnDestroy() {
      this.dispose();
    }
    transformOptions(options, field) {
      const to = this.transformSelectProps(field);
      const opts = [];
      const groups = {};
      options?.forEach(option => {
        const o = this.transformOption(option, to);
        if (o.group) {
          const id = groups[o.label];
          if (id === undefined) {
            groups[o.label] = opts.push(o) - 1;
          } else {
            o.group.forEach(o => opts[id].group.push(o));
          }
        } else {
          opts.push(o);
        }
      });
      return opts;
    }
    transformOption(option, props) {
      const group = props.groupProp(option);
      if (Array.isArray(group)) {
        return {
          label: props.labelProp(option),
          group: group.map(opt => this.transformOption(opt, props))
        };
      }
      option = {
        label: props.labelProp(option),
        value: props.valueProp(option),
        disabled: !!props.disabledProp(option)
      };
      if (group) {
        return {
          label: group,
          group: [option]
        };
      }
      return option;
    }
    transformSelectProps(field) {
      const props = field?.props || field?.templateOptions || {};
      const selectPropFn = prop => typeof prop === 'function' ? prop : o => o[prop];
      return {
        groupProp: selectPropFn(props.groupProp || 'group'),
        labelProp: selectPropFn(props.labelProp || 'label'),
        valueProp: selectPropFn(props.valueProp || 'value'),
        disabledProp: selectPropFn(props.disabledProp || 'disabled')
      };
    }
    dispose() {
      if (this._options) {
        this._options.complete();
        this._options = null;
      }
      if (this._subscription) {
        this._subscription.unsubscribe();
        this._subscription = null;
      }
    }
    observableOf(options, f) {
      this.dispose();
      if (f && f.options && f.options.fieldChanges) {
        this._subscription = f.options.fieldChanges.pipe(filter(({
          property,
          type,
          field
        }) => {
          return type === 'expressionChanges' && (property.indexOf('templateOptions.options') === 0 || property.indexOf('props.options') === 0) && field === f && Array.isArray(field.props.options) && !!this._options;
        }), tap(() => this._options.next(f.props.options))).subscribe();
      }
      this._options = new BehaviorSubject(options);
      return this._options.asObservable();
    }
    static {
      this.ɵfac = function FormlySelectOptionsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormlySelectOptionsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formlySelectOptions",
        type: FormlySelectOptionsPipe,
        pure: true
      });
    }
  }
  return FormlySelectOptionsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LegacyFormlySelectOptionsPipe = /*#__PURE__*/(() => {
  class LegacyFormlySelectOptionsPipe extends FormlySelectOptionsPipe {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵLegacyFormlySelectOptionsPipe_BaseFactory;
        return function LegacyFormlySelectOptionsPipe_Factory(__ngFactoryType__) {
          return (ɵLegacyFormlySelectOptionsPipe_BaseFactory || (ɵLegacyFormlySelectOptionsPipe_BaseFactory = i0.ɵɵgetInheritedFactory(LegacyFormlySelectOptionsPipe)))(__ngFactoryType__ || LegacyFormlySelectOptionsPipe);
        };
      })();
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formlySelectOptions",
        type: LegacyFormlySelectOptionsPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return LegacyFormlySelectOptionsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormlySelectModule = /*#__PURE__*/(() => {
  class FormlySelectModule {
    static {
      this.ɵfac = function FormlySelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormlySelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FormlySelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return FormlySelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FormlySelectModule, FormlySelectOptionsPipe, LegacyFormlySelectOptionsPipe };
